import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Dispatcher } from "../SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import SearchIcon from "@mui/icons-material/Search";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../../common/SearchBar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { handleSearchCameras } from "./SitesPageUtils/handleSearchCameras";
import { NavigateFunction } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHead, Tooltip } from "@mui/material";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import CircularProgress from "@mui/material/CircularProgress";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { TableHeadComponentSmallerText } from "../../../common/TableHead";
import { checkedCircleIconSmall } from "../../../common/checkedCircleIcon";
import { cancelIconRedSmall } from "../../../common/cancelIconRed";
export const SearchCamerasDialog = ({
  searchCamerasDialogOpen,
  setSearchCamerasDialogOpen,
  navigate,
}: {
  searchCamerasDialogOpen: boolean;
  setSearchCamerasDialogOpen: Dispatcher<boolean>;
  navigate: NavigateFunction;
}) => {
  const [inputValue, setInputValue] = React.useState("");
  const [searchCameraResults, setSearchCameraResults] = React.useState([]);
  const [searchingCameras, setSearchingCameras] = React.useState(false);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [moreToLoad, setMoreToLoad] = React.useState(false);
  const [loadingMore, setLoadingMore] = React.useState(false);
  const [fullScreenOn, setFullScreenOn] = React.useState(false);

  React.useEffect(() => {
    if (inputValue === "") {
      setSearchCameraResults([]);
      localStorage.setItem("searchCameraInputValue", "");
      return;
    } else {
      setSearchingCameras(true);
      setMoreToLoad(false);
      setPageNumber(1);
      const timer = setTimeout(() => {
        handleSearchCameras(
          inputValue,
          setSearchCameraResults,
          setSearchingCameras,
          setMoreToLoad,
          1,
          setPageNumber,
          setLoadingMore,
          navigate
        );
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [inputValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchCameraResults([]);
    setInputValue(event.target.value);
    localStorage.setItem("searchCameraInputValue", event.target.value);
  };

  return (
    <Dialog
      open={searchCamerasDialogOpen}
      fullWidth
      maxWidth="md"
      fullScreen={fullScreenOn}
    >
      <IconButton
        aria-label="close"
        onClick={() => setFullScreenOn(!fullScreenOn)}
        sx={(theme) => ({
          position: "absolute",
          left: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        {fullScreenOn ? (
          <FullscreenExitIcon fontSize="large" />
        ) : (
          <Tooltip title="Full Screen" placement="bottom-start">
            <FullscreenIcon fontSize="large" />
          </Tooltip>
        )}
      </IconButton>
      <DialogTitle
        sx={{
          fontFamily: "mulish",
          fontSize: "20px",
          fontWeight: "bold",
          paddingLeft: "70px",
        }}
      >
        {"Search Cameras"}
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={() => setSearchCamerasDialogOpen(false)}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <div>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              defaultValue={inputValue}
              placeholder="Search Cameras..."
              onChange={handleChange}
              inputProps={{ "aria-label": "search" }}
            />
          </Search>
          {searchCameraResults.length > 0 && !searchingCameras && (
            <TableContainer
              component={Paper}
              sx={
                fullScreenOn
                  ? {
                      maxHeight: "calc(100vh - 200px)",
                      minWidth: "1500px",
                      width: "100%",
                      overflow: "auto",
                    }
                  : {
                      maxHeight: 400,
                      minWidth: "1500px",
                      width: 850,
                      overflow: "auto",
                    }
              }
              className="mt-[20px]"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                sx={{ tableLayout: "fixed" }}
              >
                <TableHeadComponentSmallerText
                  titlesArray={[
                    "Camera Name",
                    "Site Name",
                    "Active",
                    "Host",
                    "RTSP",
                    "HTTP",
                    "Server Port",
                    "Immix/Sureview Email",
                    "",
                  ]}
                />
                <TableBody>
                  {searchCameraResults.map((camera: any) =>
                    camera.camera_name ? (
                      <TableRow key={camera.id}>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            maxWidth: "150px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.camera_name}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            maxWidth: "150px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.site.name}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            width: "60px",
                            textAlign: "center",
                          }}
                        >
                          {camera.active
                            ? checkedCircleIconSmall
                            : cancelIconRedSmall}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            maxWidth: "180px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.ip ? camera.ip : "--"}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            width: "80px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.rtsp ? camera.rtsp : "--"}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            width: "80px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.http ? camera.http : "--"}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            width: "100px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.server_port ? camera.server_port : "--"}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: 12,
                            maxWidth: "200px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {camera.alert_emails ? camera.alert_emails : "--"}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontSize: 12,
                            width: "120px",
                            textAlign: "center",
                          }}
                        >
                          <OrangeTextButton
                            onClick={() => {
                              navigate(
                                `/sites/${camera.site.id}/editcamera/${camera.id}`
                              );
                              setSearchCamerasDialogOpen(false);
                            }}
                            text="See Camera"
                            disabled={false}
                          />
                        </TableCell>
                      </TableRow>
                    ) : null
                  )}
                  {moreToLoad ? (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <div className="flex justify-center">
                          {loadingMore ? (
                            <CircularProgress color="primary" />
                          ) : (
                            <OrangeTextButton
                              onClick={() => {
                                setLoadingMore(true);
                                handleSearchCameras(
                                  inputValue,
                                  setSearchCameraResults,
                                  setSearchingCameras,
                                  setMoreToLoad,
                                  pageNumber,
                                  setPageNumber,
                                  setLoadingMore,
                                  navigate
                                );
                              }}
                              text="Load More"
                              disabled={false}
                            />
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {searchingCameras && (
            <div className="flex flex-col justify-center items-center">
              <CircularProgress color="primary" />
              <p
                style={{
                  marginTop: "10px",
                  font: "16px",
                  fontFamily: "mulish",
                }}
              >
                Searching Cameras...
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
